import { useCallback, useState } from 'react';

type UseTaskExpansionReturn = Readonly<{
	isExpanded: (index: number) => boolean;
	toggleExpansion: (index: number) => void;
}>;

export function useTaskExpansion(defaultExpandedIndex: number = 0): UseTaskExpansionReturn {
	const [expandedIndex, setExpandedIndex] = useState<number | null>(defaultExpandedIndex);

	const isExpanded = useCallback((index: number) => expandedIndex === index, [expandedIndex]);

	const toggleExpansion = useCallback(
		(index: number) => {
			setExpandedIndex((current) => (current === index ? null : index));
		},
		[setExpandedIndex],
	);

	return { isExpanded, toggleExpansion };
}
